import type { LocalesForNewsletterRegistration } from '$lib/components/footer/types';
import type { SupportedLocale } from '@viamichelin/business';

export const mapNewsletterRegistrationLinksByLocale: Record<
	LocalesForNewsletterRegistration,
	string
> = {
	'de-CH':
		'https://3fe75001.sibforms.com/serve/MUIFAIWy7SapLrJWaX09OABCZ2cFKN0dkChegk0cfOW6y6oRStI4huJImF4-VOAEF3Sc1OepOFzxCGZgoBgrVFlZ-1TUb8Wk13uWMbmbNtbu8h2qS1FEEwAnkmNhdtCqwo98AJpzEapRzOxTXBOzFbIA0txBKQfLVCH8KeeEW8HBjhNmChr6mWfl-yFnDGh4Q0jvl0ARoHDDRhdB',
	'de-DE':
		'https://3fe75001.sibforms.com/serve/MUIFAIWy7SapLrJWaX09OABCZ2cFKN0dkChegk0cfOW6y6oRStI4huJImF4-VOAEF3Sc1OepOFzxCGZgoBgrVFlZ-1TUb8Wk13uWMbmbNtbu8h2qS1FEEwAnkmNhdtCqwo98AJpzEapRzOxTXBOzFbIA0txBKQfLVCH8KeeEW8HBjhNmChr6mWfl-yFnDGh4Q0jvl0ARoHDDRhdB',
	'en-GB':
		'https://3fe75001.sibforms.com/serve/MUIFAE4uCz6Cp6nEbihoRwf8qiG6vPCdJyKqFMRTIGF6KcnsqoGe23G_SWXmlfkrrdLRyzEepXZxM8Ri4g-QM2p4wijAiy3WyNvZzD40JC5w59U5L-EgZUP9AmqZZJhBT32u5NxwDbB3iuztot1E_eJk87iTk2-yM8edeclYLxz7DkIFAnce9_wv1vPJJGtvED_x2JpVfQk1IYC0',
	'en-IE':
		'https://3fe75001.sibforms.com/serve/MUIFAE4uCz6Cp6nEbihoRwf8qiG6vPCdJyKqFMRTIGF6KcnsqoGe23G_SWXmlfkrrdLRyzEepXZxM8Ri4g-QM2p4wijAiy3WyNvZzD40JC5w59U5L-EgZUP9AmqZZJhBT32u5NxwDbB3iuztot1E_eJk87iTk2-yM8edeclYLxz7DkIFAnce9_wv1vPJJGtvED_x2JpVfQk1IYC0',
	'en-US':
		'https://3fe75001.sibforms.com/serve/MUIFAE4uCz6Cp6nEbihoRwf8qiG6vPCdJyKqFMRTIGF6KcnsqoGe23G_SWXmlfkrrdLRyzEepXZxM8Ri4g-QM2p4wijAiy3WyNvZzD40JC5w59U5L-EgZUP9AmqZZJhBT32u5NxwDbB3iuztot1E_eJk87iTk2-yM8edeclYLxz7DkIFAnce9_wv1vPJJGtvED_x2JpVfQk1IYC0',
	'es-ES':
		'https://3fe75001.sibforms.com/serve/MUIFANQmnE3r44RaMMhZUf1q0TyTvMxWd0L2TKua9be7tURMzILanxEHItwT0m3hT1gixa_CsX1M34UqQdgXIMRN4FSkbqPrcBLFC9m8EivkcA70IJwXoyENveyzJ2kUZJpmix1yq1SQ1AGaFWe4vGL663dD_jaRS93_EAxOWBRAu_dFoT7IrcQBSlaa6hbkp7FzVSKft1-dtBaV',
	'it-CH':
		'https://3fe75001.sibforms.com/serve/MUIFANlMbnUptVAGT0kqeUgqFzeXt-xz7eeEGgl6fLw68AYJEYYiF5CAK9l28HlGGzEJZ7srI4StVKwwUR97kSx8juJOWPA3wQ8NsPs9K9fg1HRz1XfTo8jjyzF8IFVp6SY8d9VfFHIQCwCYEGJyU8J0M9pFE4Yf0Yc_6h_OO_NP04nT_j5Y35u6wYggSCY9JiqQ250zPsiR2Sv9',
	'it-IT':
		'https://3fe75001.sibforms.com/serve/MUIFANlMbnUptVAGT0kqeUgqFzeXt-xz7eeEGgl6fLw68AYJEYYiF5CAK9l28HlGGzEJZ7srI4StVKwwUR97kSx8juJOWPA3wQ8NsPs9K9fg1HRz1XfTo8jjyzF8IFVp6SY8d9VfFHIQCwCYEGJyU8J0M9pFE4Yf0Yc_6h_OO_NP04nT_j5Y35u6wYggSCY9JiqQ250zPsiR2Sv9',
	'fr-BE':
		'https://3fe75001.sibforms.com/serve/MUIFAA2ipZWrz_tEahaGEcZY0LEEJVEtBxVw_XjR67pxkenWVQmmc3FVEi4WEoZdn7zVYmRhoxqHnBOiB2hmB4uyK80rLTGTqnQssnL4FCvnDPjYBmYTRcKfKvpIg-19i9Xvg5cvN6w1AIFy26nhAdBohQN_8QUR2ZG9NTd9m47qfNB2QwehWbwUfhIbQiMZur22Aw_GCaQ311fE',
	'fr-CH':
		'https://3fe75001.sibforms.com/serve/MUIFAA2ipZWrz_tEahaGEcZY0LEEJVEtBxVw_XjR67pxkenWVQmmc3FVEi4WEoZdn7zVYmRhoxqHnBOiB2hmB4uyK80rLTGTqnQssnL4FCvnDPjYBmYTRcKfKvpIg-19i9Xvg5cvN6w1AIFy26nhAdBohQN_8QUR2ZG9NTd9m47qfNB2QwehWbwUfhIbQiMZur22Aw_GCaQ311fE',
	'fr-FR':
		'https://3fe75001.sibforms.com/serve/MUIFAA2ipZWrz_tEahaGEcZY0LEEJVEtBxVw_XjR67pxkenWVQmmc3FVEi4WEoZdn7zVYmRhoxqHnBOiB2hmB4uyK80rLTGTqnQssnL4FCvnDPjYBmYTRcKfKvpIg-19i9Xvg5cvN6w1AIFy26nhAdBohQN_8QUR2ZG9NTd9m47qfNB2QwehWbwUfhIbQiMZur22Aw_GCaQ311fE',
};

export const localesUnauthorizedToShowRegistrations: LocalesForNewsletterRegistration[] = [
	'de-CH',
	'de-DE',
	'en-GB',
	'en-IE',
	'en-US',
	'es-ES',
	'fr-BE',
	'fr-CH',
	'fr-FR',
	'it-CH',
	'it-IT',
];

export function isLocaleAuthorizedToShowRegistrations(
	locale: SupportedLocale,
): locale is LocalesForNewsletterRegistration {
	return localesUnauthorizedToShowRegistrations.includes(
		locale as LocalesForNewsletterRegistration,
	);
}
